import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[pplKeyboardSelect]',
  standalone: true
})
export class KeyboardSelectDirective {

  @Output() keyboardSelected = new EventEmitter<KeyboardEvent>();
  
  @HostListener('keydown', ['$event'])
  handleKeydown(event: KeyboardEvent) {
    const { key, code } = event;
    if (key === 'Enter' || code === 'Space') {
      this.keyboardSelected.emit(event);
    }
  }

}
